// src/api/axios.js

import axios from "axios";

// Crear instancia de Axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:4000/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Bandera para evitar múltiples redirecciones simultáneas
let isRefreshing = false;
let failedQueue = [];

// Procesa la cola de peticiones en espera
const processQueue = (error) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });

  failedQueue = [];
};

// ==========================
// Request Interceptor
// ==========================
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);
// ==========================
// Response Interceptor
// ==========================
api.interceptors.response.use(
  (response) => response,

  (error) => {
    const originalRequest = error.config;
    const url = originalRequest?.url || "";

    // Rutas donde un 401 significa "credenciales incorrectas",
    // no "sesión expirada". Se dejan pasar al componente.
    const rutasPublicas = ["/login", "/auth/"];
    const esRutaPublica = rutasPublicas.some((ruta) => url.includes(ruta));

    if (error.response?.status === 401 && !esRutaPublica) {
      // Sesión expirada o token inválido
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");

      // Evita redirigir en bucle si ya estás en /login
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);
export default api;